import React from 'react';
import './KYCStatusBar.css';

const STAGES = [
  { key: 'SUBMITTED', label: 'Submitted' },
  { key: 'UNDER_REVIEW', label: 'Under Review' },
  { key: 'APPROVED', label: 'Approved' },
  { key: 'REJECTED', label: 'Rejected' }
];

const normalize = (status) => {
  if (!status) return 'DRAFT';
  const upper = String(status).toUpperCase();
  if (upper === 'IN_REVIEW') return 'UNDER_REVIEW';
  if (upper === 'VERIFIED' || upper === 'ACTIVE') return 'APPROVED';
  return upper;
};

const KYCStatusBar = ({ status }) => {
  const current = normalize(status);

  // If approved, only show the Approved chip and hide the rest
  if (current === 'APPROVED') {
    return (
      <div className="kyc-statusbar">
        <div className="kyc-statusbar-segment">
          <div className={[
            'kyc-statusbar-node',
            'active',
            'reached'
          ].join(' ').trim()} aria-current="step">
            <span className="kyc-statusbar-label">Approved</span>
          </div>
        </div>
      </div>
    );
  }

  const isReached = (stageKey) => {
    const order = ['DRAFT', 'SUBMITTED', 'UNDER_REVIEW', 'APPROVED'];
    const idx = order.indexOf(current);
    const stageIdx = order.indexOf(stageKey);
    if (current === 'REJECTED') {
      return stageKey === 'SUBMITTED' || stageKey === 'UNDER_REVIEW' || stageKey === 'REJECTED';
    }
    return stageIdx !== -1 && stageIdx <= idx;
  };

  return (
    <div className="kyc-statusbar">
      {STAGES.map((stage, i) => (
        <div key={stage.key} className="kyc-statusbar-segment">
          <div
            className={[
              'kyc-statusbar-node',
              current === stage.key ? 'active' : '',
              isReached(stage.key) ? 'reached' : '',
              stage.key === 'REJECTED' && current === 'REJECTED' ? 'rejected' : ''
            ].join(' ').trim()}
            aria-current={current === stage.key ? 'step' : undefined}
          >
            <span className="kyc-statusbar-label">{stage.label}</span>
          </div>
          {i < STAGES.length - 1 && (
            <div className={[
              'kyc-statusbar-connector',
              isReached(STAGES[i + 1].key) ? 'reached' : ''
            ].join(' ').trim()} />
          )}
        </div>
      ))}
    </div>
  );
};

export default KYCStatusBar;


